const _excluded = ["id", "name", "url", "highlighted", "iconUrl", "hasDivider"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';
import * as analytics from '@adsk/acs-web-analytics';
import { useAlloyFeatureFlag } from '@adsk/alloy-provider';
import { Box } from '@adsk/alloy-react-box';
import { HomeIcon } from '@adsk/alloy-react-icon';
import { MenuList, MenuItem } from '@adsk/alloy-react-menu';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { ANALYTICS_TYPES } from '../helpers/analytics';
import getAnchorRel from '../helpers/getAnchorRel';
import getAnchorTarget from '../helpers/getAnchorTarget';
import { productsListShape } from '../helpers/propTypes';
// TODO - can be removed when account entitlement is available in V2
// TODO - verify it works as expected
const getProductIconV1 = product => {
  var _product$renderIcon;
  return product === null || product === void 0 ? void 0 : (_product$renderIcon = product.renderIcon) === null || _product$renderIcon === void 0 ? void 0 : _product$renderIcon.call(product, {
    size: 24
  });
};
const parser = (products, selectedId) => (products === null || products === void 0 ? void 0 : products.map(product => _objectSpread(_objectSpread({}, product), {}, {
  id: product.key,
  url: product.defaultUrl,
  highlighted: product.key === selectedId
}))) || [];
const MY_HOME_MENU_ITEM_ID = 'myHome';
const MenuItemText = styled.div.withConfig({
  displayName: "ProductPicker__MenuItemText",
  componentId: "sc-1o47157-0"
})(_objectSpread(_objectSpread(_objectSpread({}, theme.typography.bodyMedium), theme.typography.ellipsis), {}, {
  flex: 1,
  paddingLeft: 10,
  textAlign: 'left'
}));
const MenuItemWrapper = styled.div.withConfig({
  displayName: "ProductPicker__MenuItemWrapper",
  componentId: "sc-1o47157-1"
})({
  borderBottom: "1px solid ".concat(theme.colors.charcoal200)
});
const ProductPicker = _ref => {
  let {
    className,
    style,
    products,
    selectedId,
    onClose,
    onProductClick,
    renderCustomHeader = () => null
  } = _ref;
  const {
    value: showUserHomeTab
  } = useAlloyFeatureFlag('show-user-home-tab');
  const onProductClickWithAnalytic = useCallback(id => {
    analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_PROJECTPICKER_PRODUCT_CLICK, {
      product_id: id,
      prev_product_id: selectedId
    });
  }, [selectedId]);
  const getMenuItemProps = _ref2 => {
    let {
      id,
      url
    } = _ref2;
    return {
      as: onProductClick ? 'button' : 'a',
      'data-testid': "ProductPicker__product-".concat(id),
      href: url,
      target: url && getAnchorTarget(url),
      rel: getAnchorRel(url),
      nested: false,
      showSelection: false,
      onClick: event => {
        onProductClick === null || onProductClick === void 0 ? void 0 : onProductClick({
          id,
          url
        }, event);
        onProductClickWithAnalytic(id);
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };
  };
  return /*#__PURE__*/React.createElement(Box, {
    className: className,
    width: "300px",
    style: style
  }, /*#__PURE__*/React.createElement(MenuList, null, showUserHomeTab && /*#__PURE__*/React.createElement(MenuItemWrapper, null, /*#__PURE__*/React.createElement(MenuItem, _extends({}, getMenuItemProps({
    id: MY_HOME_MENU_ITEM_ID,
    url: "".concat(getAccOrigin(), "/home")
  }), {
    key: MY_HOME_MENU_ITEM_ID,
    highlighted: MY_HOME_MENU_ITEM_ID === selectedId,
    style: {
      marginBottom: '8px'
    }
  }), /*#__PURE__*/React.createElement(HomeIcon, {
    size: 24
  }), /*#__PURE__*/React.createElement(MenuItemText, null, "My Home"))), renderCustomHeader(), parser(products, selectedId).map(_ref3 => {
    let {
        id,
        name,
        url,
        highlighted,
        iconUrl,
        hasDivider
      } = _ref3,
      rest = _objectWithoutProperties(_ref3, _excluded);
    return /*#__PURE__*/React.createElement(MenuItem, _extends({}, getMenuItemProps({
      id,
      url
    }), {
      key: id,
      highlighted: highlighted,
      style: {
        borderTop: hasDivider ? "1px solid ".concat(theme.colors.charcoal200) : 'none',
        height: 40,
        borderRadius: 0
      }
    }), iconUrl ? /*#__PURE__*/React.createElement(Box, {
      bg: highlighted ? 'white' : 'charcoal900',
      width: "24px",
      height: "24px",
      style: {
        maskImage: "url(".concat(iconUrl, ")")
      }
    }) : getProductIconV1(rest), /*#__PURE__*/React.createElement(MenuItemText, null, name));
  })));
};
ProductPicker.displayName = 'ProductPicker';
ProductPicker.defaultProps = {
  renderCustomHeader: () => null
};
ProductPicker.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Products list */
  products: productsListShape,
  /** Selected product ID */
  selectedId: PropTypes.string,
  /** menu close handler */
  onClose: PropTypes.func,
  /** Custom product click handler, unsafe */
  onProductClick: PropTypes.func,
  /** render custom header */
  renderCustomHeader: PropTypes.func
};
export default ProductPicker;
//# sourceMappingURL=ProductPicker.js.map